import type { FaireBrandEntity } from "../../entity_types/brand";

// Kaari & Co. — real Faire brand (b_7xqoxri3cq). Identity metadata from
// ANALYTICS.CANONICAL.BRANDS; backs the ads-manager-2 "Kaari & Co."
// real-brand variant (advertiser 1756243082779176848).
export const b_7xqoxri3cq: FaireBrandEntity = {
  token: "b_7xqoxri3cq",
  type: "brand",
  name: "Kaari & Co.",
  description:
    "Whimsical, intricate nature drawings printed as paper goods and lifestyle pieces on recycled hemp paper.",
  location: "Portland, OR, USA",
  isTopShop: true,
  tags: ["paper-novelty", "art-prints", "stationery"],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
